import { StandardsModalFooter } from "./StandardsModalFooter.component";

export { StandardsModalFooter };
